export default ['Locked', 'Unlocked'];
